// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'Ladataan muutosta…',
  load_failed: 'En voinut ladata tätä muutosta.',
  load_retry: 'Yritä uudelleen',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Tämä oli jo hyväksytty, joten mitään ei tarvinnut tehdä enää.',
  action_failed: 'Se ei mennyt läpi, joten mikään ei muuttunut. Yritä hetken kuluttua uudelleen.',
  removed: 'Poistettu',
  retry: 'Yritä uudelleen',
  retry_one: 'Yritä uudelleen: {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Hyväksytty.',
    retried: 'Yritetty uudelleen.',
    rejected: 'Hylätty.',
  },
  done: {
    summary_one: 'Valmis. {{count}} muutos otettu käyttöön.',
    summary_other: 'Valmis. {{count}} muutosta otettu käyttöön.',
    skipped_one: '{{count}} ohitettu, mikään ei muuttunut sen osalta.',
    skipped_other: '{{count}} ohitettu, mikään ei muuttunut niiden osalta.',
  },
  partial: {
    summary_one: '{{applied}} / {{approved}} muutosta otettu käyttöön. {{count}} ei onnistunut.',
    summary_other: '{{applied}} / {{approved}} muutosta otettu käyttöön. {{count}} ei onnistunut.',
    detail_one: '{{applied}} on tallennettu. Alla oleviin {{count}} ei tullut muutoksia.',
    detail_other: '{{applied}} on tallennettu. Alla oleviin {{count}} ei tullut muutoksia.',
  },
  stale: {
    summary: '{{applied}} / {{approved}} muutosta otettu käyttöön.',
    detail_one: 'Joku muu muutti {{count}} muutoksen välissä.',
    detail_other: 'Joku muu muutti {{count}} muutosta välissä.',
    reason:
      '{{name}} muutti arvoksi {{value}} kello {{time}}, ennen kuin hyväksyit, joten jätin sen ennalleen. Tässä se uudelleen uudesta arvosta:',
  },
  undone: {
    summary_one: 'Kumottu. {{count}} muutos on palautettu ennalleen.',
    summary_other: 'Kumottu. {{count}} muutosta on palautettu ennalleen.',
    detail: 'Kumoaminen kirjataan myös Amigon lokiin ja kohtaan Menu → Muokkaushistoria.',
  },
  summary: {
    average: '{{amount}} annosta kohden keskimäärin',
    needs_look: 'Vaatii tarkistuksen',
    nothing_else: 'Mikään muu ei muutu',
  },
  labels: {
    waiting: 'Odottaa hyväksyntää',
    skip: 'Ohita',
    unskip: 'Peru ohitus',
    approve_all: 'Hyväksy kaikki',
    approve_one: 'Hyväksy {{count}}',
    approve_other: 'Hyväksy {{count}}',
    approve_row: 'Hyväksy',
    reject: 'Hylkää…',
    reject_confirm: 'Hylkää',
    back: 'Takaisin',
    why: {
      amigo: 'Miksi ei? (valinnainen, Amigo lukee tämän)',
      assistant: 'Miksi ei? (valinnainen, avustaja lukee tämän)',
    },
    hint: 'Tai vastaa alla muuttaaksesi jotain.',
    show_all_one: 'Näytä kaikki {{count}} muutosta',
    show_all_other: 'Näytä kaikki {{count}} muutosta',
    show_less: 'Näytä vähemmän',
    applying_one: 'Otetaan käyttöön {{count}} muutos…',
    applying_other: 'Otetaan käyttöön {{count}} muutosta…',
    rows: {
      skipped: 'Ohitettu',
      applied: 'Otettu käyttöön',
      failed: 'Ei otettu käyttöön',
      changed: 'Muuttunut välillä',
      kept: 'Jätetty ennalleen',
    },
    history: {
      amigo: 'Avaa Amigon lokissa',
      assistant: 'Avaa avustajan lokissa',
    },
    undo: 'Kumoa',
    to: 'muotoon',
    from: 'muodosta',
    rejected: 'Hylätty',
    replaced: 'Korvattu',
    expired: 'Vanhentunut',
  },
};
